import React from "react";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";

export default function SectorManagementSection({
  tx,
  sectorsError,
  fetchSectors,
  buttonStyle,
  sectorsLoading,
  sectors,
  selectedSectorId,
  loadSectorDetail,
  translationButton,
  createSector,
  sectorForm,
  setSectorForm,
  fieldStyle,
  labelStyle,
  inputStyle,
  sectorDetail,
  sectorDetailLoading,
  deleteSector,
  sectorEditForm,
  setSectorEditForm,
  updateSector,
  removeMaterialFromSector,
  materialSearch,
  searchMaterials,
  materialAddTarget,
  setMaterialAddTarget,
  selectStyle,
  materialSearchLoading,
  materialSearchError,
  materialSearchResults,
  addMaterialToSector,
  addMaterialToList,
  onListDragEnd,
  listDrafts,
  setListDrafts,
  saveListDraft,
  deleteList,
  removeMaterialFromList,
  listForm,
  setListForm,
  createList,
}) {
  return (
    <div className="col-12">
      <div className="settings-card glass-card-ui">
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div>
            <div style={{ color: "#7BD5F5", fontSize: 12, letterSpacing: 0.3 }}>{tx("Data", "Daten", "数据")}</div>
            <div style={{ color: "#fff", fontSize: 16, fontWeight: 700 }}>{tx("Material sectors & lists", "Materialsektoren & Listen", "材料行业与列表")}</div>
          </div>
          <div style={{ display: "flex", gap: 8 }}>
            <button
              type="button"
              onClick={fetchSectors}
              style={{ ...buttonStyle, padding: "8px 12px" }}
              disabled={sectorsLoading}
            >
              {tx("Refresh", "Aktualisieren", "刷新")}
            </button>
          </div>
        </div>
        {sectorsError && <div style={{ color: "#ffb3b3", fontSize: 12, marginTop: 6 }}>{sectorsError}</div>}
        <div style={{ display: "grid", gridTemplateColumns: "minmax(260px, 320px) 1fr", gap: 12, marginTop: 12 }}>
          <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
            <div style={{ border: "1px solid rgba(255,255,255,0.08)", borderRadius: 12, padding: 12, background: "rgba(255,255,255,0.03)" }}>
              <div style={{ color: "#fff", fontWeight: 700, marginBottom: 8 }}>{tx("Sectors", "Sektoren", "行业")}</div>
              {sectorsLoading && <div style={{ color: "#cfe4ff", fontSize: 12 }}>{tx("Loading sectors…", "Sektoren werden geladen…", "正在加载行业…")}</div>}
              <div style={{ display: "flex", flexDirection: "column", gap: 8, maxHeight: 360, overflow: "auto" }}>
                {sectors.map((s) => {
                  const active = selectedSectorId === s.id;
                  return (
                    <div
                      key={s.id}
                      style={{
                        display: "grid",
                        gridTemplateColumns: "1fr auto",
                        gap: 8,
                        alignItems: "start",
                      }}
                    >
                      <button
                        type="button"
                        onClick={() => loadSectorDetail(s.id)}
                        style={{
                          textAlign: "left",
                          borderRadius: 10,
                          border: active ? "1px solid #7BD5F5" : "1px solid rgba(255,255,255,0.08)",
                          background: active ? "rgba(123,213,245,0.12)" : "rgba(255,255,255,0.02)",
                          padding: 10,
                          color: "#fff",
                          cursor: "pointer",
                        }}
                      >
                        <div style={{ display: "flex", justifyContent: "space-between", gap: 6 }}>
                          <div style={{ fontWeight: 700 }}>{s.name}</div>
                          <span style={{ fontSize: 11, color: "#cfe4ff" }}>{s.material_count || 0} {tx("mats", "Materialien", "材料")}</span>
                        </div>
                        <div style={{ color: "#cfe4ff", fontSize: 12 }}>{s.list_count || 0} {tx("lists", "Listen", "列表")}</div>
                      </button>
                      {translationButton("material_sector", s.id, s.name)}
                    </div>
                  );
                })}
                {!sectorsLoading && !sectors.length && <div style={{ color: "rgba(255,255,255,0.6)", fontSize: 12 }}>{tx("No sectors yet.", "Noch keine Sektoren.", "暂无行业。")}</div>}
              </div>
            </div>

            <form onSubmit={createSector} style={{ border: "1px solid rgba(255,255,255,0.08)", borderRadius: 12, padding: 12, background: "rgba(255,255,255,0.02)", display: "flex", flexDirection: "column", gap: 10 }}>
              <div style={{ color: "#fff", fontWeight: 700 }}>{tx("Create sector", "Sektor erstellen", "创建行业")}</div>
              <div style={fieldStyle}>
                <label style={labelStyle}>{tx("Name", "Name", "名称")}</label>
                <input
                  type="text"
                  value={sectorForm.name}
                  onChange={(e) => setSectorForm((prev) => ({ ...prev, name: e.target.value }))}
                  style={inputStyle}
                  placeholder={tx("e.g., Energy", "z. B. Energie", "例如：能源")}
                  required
                />
              </div>
              <div style={fieldStyle}>
                <label style={labelStyle}>{tx("Image", "Bild", "图片")}</label>
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => setSectorForm((prev) => ({ ...prev, imageFile: e.target.files?.[0] || null }))}
                  style={inputStyle}
                />
                <div style={{ color: "rgba(255,255,255,0.6)", fontSize: 11 }}>{tx("Uploaded to media.dataflock.de/material_sectors", "Hochgeladen nach media.dataflock.de/material_sectors", "已上传到 media.dataflock.de/material_sectors")}</div>
              </div>
              <button style={buttonStyle} type="submit">{tx("Create", "Erstellen", "创建")}</button>
            </form>
          </div>

          <div style={{ border: "1px solid rgba(255,255,255,0.08)", borderRadius: 12, padding: 12, background: "rgba(255,255,255,0.02)", minHeight: 320 }}>
            {sectorDetailLoading && <div style={{ color: "#cfe4ff", fontSize: 12 }}>{tx("Loading sector…", "Sektor wird geladen…", "正在加载行业…")}</div>}
            {!sectorDetail && !sectorDetailLoading && <div style={{ color: "rgba(255,255,255,0.6)", fontSize: 13 }}>{tx("Select a sector to manage materials and lists.", "Wählen Sie einen Sektor, um Materialien und Listen zu verwalten.", "请选择行业以管理材料和列表。")}</div>}
            {sectorDetail && !sectorDetailLoading && (
              <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <div>
                    <div style={{ color: "#fff", fontWeight: 700, display: "flex", alignItems: "center", gap: 8 }}>
                      <span>{sectorDetail.name}</span>
                      {translationButton("material_sector", sectorDetail.id, sectorDetail.name)}
                    </div>
                    <div style={{ color: "#cfe4ff", fontSize: 12 }}>
                      {sectorDetail.material_count} {tx("materials", "Materialien", "材料")} · {sectorDetail.list_count} {tx("lists", "Listen", "列表")}
                    </div>
                  </div>
                  <button
                    type="button"
                    onClick={() => deleteSector(sectorDetail.id)}
                    style={{ ...buttonStyle, background: "rgba(255,97,97,0.2)", color: "#fff", border: "1px solid rgba(255,97,97,0.5)" }}
                  >
                    Delete
                  </button>
                </div>

                <form onSubmit={updateSector} style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: 10 }}>
                  <div style={fieldStyle}>
                    <label style={labelStyle}>{tx("Name", "Name", "名称")}</label>
                    <input
                      type="text"
                      value={sectorEditForm.name}
                      onChange={(e) => setSectorEditForm((prev) => ({ ...prev, name: e.target.value }))}
                      style={inputStyle}
                    />
                  </div>
                  <div style={fieldStyle}>
                    <label style={labelStyle}>{tx("Image", "Bild", "图片")}</label>
                    {sectorEditForm.imagePreview && (
                      <img src={sectorEditForm.imagePreview} alt="Sector" style={{ maxHeight: 80, objectFit: "cover", borderRadius: 10, border: "1px solid rgba(255,255,255,0.1)" }} />
                    )}
                    <input
                      type="file"
                      accept="image/*"
                      onChange={(e) => setSectorEditForm((prev) => ({ ...prev, imageFile: e.target.files?.[0] || null }))}
                      style={inputStyle}
                    />
                    <div style={{ color: "rgba(255,255,255,0.6)", fontSize: 11 }}>{tx("Upload replaces the current image", "Upload ersetzt das aktuelle Bild", "上传将替换当前图片")}</div>
                  </div>
                  <div style={{ display: "flex", alignItems: "flex-end" }}>
                    <button style={buttonStyle} type="submit">{tx("Save sector", "Sektor speichern", "保存行业")}</button>
                  </div>
                </form>

                <div style={{ borderTop: "1px solid rgba(255,255,255,0.06)", paddingTop: 10 }}>
                  <div style={{ color: "#fff", fontWeight: 700, marginBottom: 8 }}>{tx("Materials in sector", "Materialien im Sektor", "行业中的材料")}</div>
                  <div style={{ display: "grid", gap: 8, maxHeight: 320, overflowY: "auto", paddingRight: 4 }}>
                    {(sectorDetail.materials || []).map((m) => (
                      <div
                        key={m.id}
                        style={{
                          border: "1px solid rgba(255,255,255,0.1)",
                          borderRadius: 12,
                          padding: "8px 10px",
                          display: "flex",
                          alignItems: "flex-start",
                          justifyContent: "space-between",
                          gap: 10,
                        }}
                      >
                        <div style={{ minWidth: 0 }}>
                          <div style={{ fontWeight: 700, color: "#fff", display: "flex", alignItems: "center", gap: 8 }}>
                            <span style={{ wordBreak: "break-word" }}>{m.name || m.code}</span>
                            {translationButton("material", m.id, m.name || m.code)}
                          </div>
                          <div style={{ color: "#cfe4ff", fontSize: 11 }}>{m.code}</div>
                        </div>
                        <button
                          type="button"
                          onClick={() => removeMaterialFromSector(m.id)}
                          style={{ border: "none", background: "transparent", color: "#ff9c9c", cursor: "pointer", fontWeight: 700 }}
                        >
                          ×
                        </button>
                      </div>
                    ))}
                    {!sectorDetail.materials?.length && <div style={{ color: "rgba(255,255,255,0.6)", fontSize: 12 }}>{tx("No materials linked.", "Keine Materialien verknüpft.", "未关联材料。")}</div>}
                  </div>

                  <div style={{ display: "grid", gap: 8, marginTop: 10 }}>
                    <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                      <input
                        type="text"
                        value={materialSearch}
                        onChange={(e) => searchMaterials(e.target.value)}
                        placeholder={tx("Search materials to add", "Materialien zum Hinzufügen suchen", "搜索要添加的材料")}
                        style={{ ...inputStyle, flex: "1 1 240px" }}
                      />
                      <select
                        value={materialAddTarget}
                        onChange={(e) => setMaterialAddTarget(e.target.value)}
                        style={{ ...selectStyle, minWidth: 180 }}
                      >
                        <option value="sector">{tx("Add to sector", "Zum Sektor hinzufügen", "添加到行业")}</option>
                        {(sectorDetail.lists || []).map((l) => (
                          <option key={l.id} value={String(l.id)}>
                            Add to list: {l.name}
                          </option>
                        ))}
                      </select>
                      {materialSearchLoading && <div style={{ color: "#cfe4ff", fontSize: 12, alignSelf: "center" }}>{tx("Searching…", "Suche…", "搜索中…")}</div>}
                    </div>
                    {materialSearchError && <div style={{ color: "#ffb3b3", fontSize: 12 }}>{materialSearchError}</div>}
                    {materialSearchResults.length > 0 && (
                      <div style={{ display: "grid", gap: 6, gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))" }}>
                        {materialSearchResults.map((m) => (
                          <div key={m.id || m.code} style={{ border: "1px solid rgba(255,255,255,0.08)", borderRadius: 10, padding: 8, background: "rgba(255,255,255,0.02)" }}>
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                              <div style={{ color: "#fff", fontWeight: 700, display: "flex", alignItems: "center", gap: 8 }}>
                                <span>{m.name || m.code}</span>
                                {m.id ? translationButton("material", m.id, m.name || m.code) : null}
                              </div>
                              <span style={{ color: "#cfe4ff", fontSize: 11 }}>{m.code}</span>
                            </div>
                            <button
                              type="button"
                              onClick={() => {
                                if (materialAddTarget === "sector") {
                                  addMaterialToSector(m);
                                } else {
                                  const lid = Number(materialAddTarget);
                                  if (Number.isFinite(lid)) addMaterialToList(lid, m);
                                }
                              }}
                              style={{ ...buttonStyle, marginTop: 6, width: "100%", padding: "6px 8px" }}
                            >
                              {materialAddTarget === "sector" ? tx("Add to sector", "Zum Sektor hinzufügen", "添加到行业") : tx("Add to list", "Zur Liste hinzufügen", "添加到列表")}
                            </button>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>

                <div style={{ borderTop: "1px solid rgba(255,255,255,0.06)", paddingTop: 10, display: "flex", flexDirection: "column", gap: 10 }}>
                  <div style={{ color: "#fff", fontWeight: 700 }}>{tx("Lists in this sector", "Listen in diesem Sektor", "该行业中的列表")}</div>
                  <DragDropContext onDragEnd={onListDragEnd}>
                    <Droppable droppableId="lists">
                      {(provided) => (
                        <div {...provided.droppableProps} ref={provided.innerRef}>
                          {(sectorDetail.lists || []).sort((a, b) => a.sort_order - b.sort_order).map((l, index) => {
                            const draft = listDrafts[l.id] || { name: l.name, description: l.description };
                            return (
                              <Draggable key={l.id} draggableId={String(l.id)} index={index}>
                                {(dragProvided, snapshot) => (
                                  <div
                                    ref={dragProvided.innerRef}
                                    {...dragProvided.draggableProps}
                                    style={{
                                      ...dragProvided.draggableProps.style,
                                      border: snapshot.isDragging ? "1px solid rgba(123, 213, 245, 0.5)" : "1px solid rgba(255,255,255,0.08)",
                                      borderRadius: 10,
                                      padding: 10,
                                      display: "grid",
                                      gridTemplateColumns: "auto 1fr 1fr 110px",
                                      gap: 8,
                                      alignItems: "center",
                                      marginBottom: 8,
                                      background: snapshot.isDragging ? "rgba(20, 25, 38, 0.95)" : "rgba(255,255,255,0.02)",
                                      boxShadow: snapshot.isDragging ? "0 15px 35px rgba(0,0,0,0.35)" : "none",
                                    }}
                                  >
                                    <div {...dragProvided.dragHandleProps} style={{ cursor: "grab", padding: "0 8px" }}>
                                      <svg width="14" height="24" viewBox="0 0 14 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M4.5 4.5C4.5 5.05228 4.05228 5.5 3.5 5.5C2.94772 5.5 2.5 5.05228 2.5 4.5C2.5 3.94772 2.94772 3.5 3.5 3.5C4.05228 3.5 4.5 3.94772 4.5 4.5Z" fill="white" />
                                        <path d="M4.5 11.5C4.5 12.0523 4.05228 12.5 3.5 12.5C2.94772 12.5 2.5 12.0523 2.5 11.5C2.5 10.9477 2.94772 10.5 3.5 10.5C4.05228 10.5 4.5 10.9477 4.5 11.5Z" fill="white" />
                                        <path d="M4.5 18.5C4.5 19.0523 4.05228 19.5 3.5 19.5C2.94772 19.5 2.5 19.0523 2.5 18.5C2.5 17.9477 2.94772 17.5 3.5 17.5C4.05228 17.5 4.5 17.9477 4.5 18.5Z" fill="white" />
                                        <path d="M11.5 4.5C11.5 5.05228 11.0523 5.5 10.5 5.5C9.94772 5.5 9.5 5.05228 9.5 4.5C9.5 3.94772 9.94772 3.5 10.5 3.5C11.0523 3.5 11.5 3.94772 11.5 4.5Z" fill="white" />
                                        <path d="M11.5 11.5C11.5 12.0523 11.0523 12.5 10.5 12.5C9.94772 12.5 9.5 12.0523 9.5 11.5C9.5 10.9477 9.94772 10.5 10.5 10.5C11.0523 10.5 11.5 10.9477 11.5 11.5Z" fill="white" />
                                        <path d="M11.5 18.5C11.5 19.0523 11.0523 19.5 10.5 19.5C9.94772 19.5 9.5 19.0523 9.5 18.5C9.5 17.9477 9.94772 17.5 10.5 17.5C11.0523 17.5 11.5 17.9477 11.5 18.5Z" fill="white" />
                                      </svg>
                                    </div>
                                    <input
                                      type="text"
                                      value={draft.name || ""}
                                      onChange={(e) => setListDrafts((prev) => ({ ...prev, [l.id]: { ...(prev[l.id] || {}), name: e.target.value } }))}
                                      style={inputStyle}
                                      placeholder={tx("List name", "Listenname", "列表名称")}
                                    />
                                    <input
                                      type="text"
                                      value={draft.description || ""}
                                      onChange={(e) => setListDrafts((prev) => ({ ...prev, [l.id]: { ...(prev[l.id] || {}), description: e.target.value } }))}
                                      style={inputStyle}
                                      placeholder={tx("Description", "Beschreibung", "描述")}
                                    />
                                    <div style={{ display: "flex", gap: 6 }}>
                                      {translationButton("report_list", l.id, draft.name || l.name)}
                                      <button type="button" onClick={() => saveListDraft(l.id)} style={{ ...buttonStyle, padding: "6px 8px" }}>
                                        {tx("Save", "Speichern", "保存")}
                                      </button>
                                      <button
                                        type="button"
                                        onClick={() => deleteList(l.id)}
                                        style={{ ...buttonStyle, padding: "6px 8px", background: "rgba(255,97,97,0.2)", color: "#fff", border: "1px solid rgba(255,97,97,0.5)" }}
                                      >
                                        {tx("Delete", "Löschen", "删除")}
                                      </button>
                                    </div>
                                    {l.materials?.length ? (
                                      <div style={{ gridColumn: "1 / -1", display: "flex", gap: 8, flexWrap: "wrap", paddingLeft: 30 }}>
                                        {l.materials.map((m) => (
                                          <div key={`${l.id}-${m.id}`} style={{ border: "1px solid rgba(255,255,255,0.1)", borderRadius: 10, padding: "6px 8px", display: "flex", alignItems: "center", gap: 6 }}>
                                            <div>
                                              <div style={{ color: "#fff", fontWeight: 700, display: "flex", alignItems: "center", gap: 8 }}>
                                                <span>{m.name || m.code}</span>
                                                {translationButton("material", m.id, m.name || m.code)}
                                              </div>
                                              <div style={{ color: "#cfe4ff", fontSize: 11 }}>{m.code}</div>
                                            </div>
                                            <button
                                              type="button"
                                              onClick={() => removeMaterialFromList(l.id, m.id)}
                                              style={{ border: "none", background: "transparent", color: "#ff9c9c", cursor: "pointer", fontWeight: 700 }}
                                            >
                                              ×
                                            </button>
                                          </div>
                                        ))}
                                      </div>
                                    ) : (
                                      <div style={{ gridColumn: "1 / -1", color: "rgba(255,255,255,0.6)", fontSize: 12, paddingLeft: 30 }}>{tx("No materials in this list yet.", "Noch keine Materialien in dieser Liste.", "此列表中暂无材料。")}</div>
                                    )}
                                  </div>
                                )}
                              </Draggable>
                            );
                          })}
                          {provided.placeholder}
                        </div>
                      )}
                    </Droppable>
                  </DragDropContext>
                  {!sectorDetail.lists?.length && <div style={{ color: "rgba(255,255,255,0.6)", fontSize: 12 }}>{tx("No lists yet.", "Noch keine Listen.", "暂无列表。")}</div>}

                  <form onSubmit={createList} style={{ border: "1px dashed rgba(255,255,255,0.2)", borderRadius: 10, padding: 10, display: "grid", gridTemplateColumns: "1fr 1fr auto", gap: 8, alignItems: "center" }}>
                    <input
                      type="text"
                      value={listForm.name}
                      onChange={(e) => setListForm((prev) => ({ ...prev, name: e.target.value }))}
                      style={inputStyle}
                      placeholder={tx("New list name", "Neuer Listenname", "新列表名称")}
                      required
                    />
                    <input
                      type="text"
                      value={listForm.description}
                      onChange={(e) => setListForm((prev) => ({ ...prev, description: e.target.value }))}
                      style={inputStyle}
                      placeholder={tx("Description (optional)", "Beschreibung (optional)", "描述（可选）")}
                    />
                    <button type="submit" style={{ ...buttonStyle, padding: "6px 8px" }}>
                      {tx("Add list", "Liste hinzufügen", "添加列表")}
                    </button>
                  </form>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
